// First-touch attribution: remember where a visitor came from (?ref=, ?utm_*) for
// 30 days and send it with the signup, so the database knows which channel or
// partner every user came from. An existing fresh value is never overwritten.
const KEY = 'dl_attr';
const TTL = 30 * 864e5;

export const captureAttribution = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    const ref = p.get('ref');
    const source = p.get('utm_source');
    if (!ref && !source) return;
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    const fresh = !saved || Date.now() - saved.ts > TTL;
    if (!fresh) return;
    localStorage.setItem(KEY, JSON.stringify({
      ref,
      utm_source: source,
      utm_medium: p.get('utm_medium'),
      utm_campaign: p.get('utm_campaign'),
      landing: window.location.pathname,
      ts: Date.now(),
    }));
  } catch { /* storage blocked: attribution is best-effort */ }
};

export const getAttribution = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || 'null');
    return a && Date.now() - a.ts <= TTL ? a : null;
  } catch {
    return null;
  }
};

// UTM/ref in the CURRENT url (sent with each page view, so traffic by source is
// known even for visitors who never sign up).
export const currentUrlCampaign = () => {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get('utm_source'), utm_medium: p.get('utm_medium'),
      utm_campaign: p.get('utm_campaign'), ref: p.get('ref'),
    };
  } catch {
    return {};
  }
};
